export default function MaxWidthWrapper({ children }) {
    return (
      <div className="flex w-full justify-center">
        <div className="px-5 sm:px-10 lg:px-20 w-full max-w-[1440px]">{children}</div>
      </div>
    );
  }
  